'use strict';

/**
 *
 * @name: apiNotificationsService
 *
 */

function ApiNotificationsService(
  $rootScope,
  $http,
  $q,
  transObject,
  $interval,
  translateDate
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function buildNotification(item) {

    if (item.notifier) {

      item.notifier.urlName = item.notifier.displayName.replace(/\s/g, '-');
    }

    if (item.post) {

      transObject.translate(item.post);
      transObject.trueSlug(item.post);
    }

    if (item.playlist) {

      transObject.translate(item.playlist);
      transObject.trueSlug(item.playlist);
    }

    item.timeAgo = moment(item.createdAt).fromNow();

    switch (item.type) {

      case 'follow':
        item.icon = 'icon-user-plus';
        item.text = 'NOTIFICATION_IS_NOW_FOLLOWING_YOU';
        item.cssClass = '-type-user-follow';
        break;

      case 'unfollow':

        item.icon = 'icon-user';
        item.text = 'NOTIFICATION_STOPPED_FOLLOWING_YOU';
        item.cssClass = '-type-user-unfollow';
        break;

      case 'commentCreate':

        item.icon = 'icon-comment';
        item.text = 'NOTIFICATION_ALSO_COMMENTED';
        item.cssClass = '-type-comment-create';
        break;

      case 'postAvailable':

        item.icon = 'icon-star';
        item.text = 'NOTIFICATION_POST_AVAILABLE';
        item.cssClass = '-type-post-avaible';
        break;

      case 'postCreate':

        item.icon = 'icon-star';
        item.text = 'NOTIFICATION_POST_CREATED';
        item.cssClass = '-type-post-create';
        break;

      case 'playlistCreate':

        item.icon = 'icon-list';
        item.text = 'NOTIFICATION_PLAYLIST_CREATED';
        item.cssClass = '-type-playlist-create';
        break;

      case 'playlistLove':

        item.icon = 'icon-heart-full';
        item.text = 'NOTIFICATION_RATED_YOUR_PLAYLIST';
        item.cssClass = '-type-playlist-love';
        break;

      case 'playlistUnlove':

        item.icon = 'icon-info';
        item.text = 'NOTIFICATION_PLAYLIST_UNLOVE';
        item.cssClass = '-type-playlist-unlove';
        break;

      case 'postLove':

        item.icon = 'icon-star';
        item.text = 'NOTIFICATION_TOP_RATED_WATCH_IT';
        item.cssClass = '-type-post-love';
        break;

      case 'custom':

        item.icon = 'icon-info';
        item.cssClass = '-type-custom';
        break;

    }

    return item;
  }

  function getNotifications(page, limit, isNew, createdAfter) {

    var target = $rootScope.apiUrlNew +
      '/notification?' +
      '&UserId=' +
      $rootScope.profile.id +
      '&page=' +
      (page ? page : 1) +
      (limit ? '&limit=' + limit : '') +
      (typeof isNew === 'boolean' ? '&isNew=' + isNew : '') +
      (createdAfter ? '&createdAfter=' + createdAfter : '');

    return $http
      .get(target)
      .success(function(response) {

        angular.forEach(response.items, function(item) {

          if (item.post) {

            item.post.publishedAt = translateDate(item.post.publishedAt);
          }
        });
      });
  }

  function markAsRead() {

    var target = $rootScope.apiUrlNew + '/notification/markasread';

    return $http.put(target);
  }

  function removePolling() {

    if ($rootScope.notificationsPolling) {

      $interval.cancel($rootScope.notificationsPolling);
    }
  }

  function watchAndPoll() {

    if ($rootScope.profile) {

      loadUserFeedNotifications();
      _setInterval();
    } else {

      var watchProfile = $rootScope.$watch('profile', function(newVal) {
        if (newVal) {
          watchProfile();

          loadUserFeedNotifications();
          _setInterval();
        }
      });
    }
  }

  function loadUserFeedNotifications() {

    getNotifications(1, 8)
      .then(function(res) {

        var HAS_UNREAD = 0;

        $rootScope.notifications.data = res.data.items
          .map(function(item) {

            if (item.isNew) {

              HAS_UNREAD++;
            }

            if (item.notifier) {

              transObject.trueSlug(item.notifier);
            }

            if (item.otherNotificationUsers) {

              item.otherNotificationUsers.forEach(function(user) {

                transObject.trueSlug(user);
              });
            }

            buildNotification(item);
            return item;
          });

        $rootScope.notifications.hasUnread = !!HAS_UNREAD;

        $rootScope.notifications.counter = $rootScope.notifications.data
          .reduce(function(acc, item) {

            if (item.isNew) {
              acc += 1;
            }

            return acc;
          }, 0);
      });
  }

  /**
   *
   * @PRIVATE
   *
   */

  function _setInterval() {

    $rootScope.notificationsPolling = $interval(function() {

      loadUserFeedNotifications();
    }, 213000);
  }

  return {

    buildNotification: buildNotification,
    getNotifications: getNotifications,
    markAsRead: markAsRead,
    removePolling: removePolling,
    watchAndPoll: watchAndPoll,
    loadUserFeedNotifications: loadUserFeedNotifications
  };
}

export default ApiNotificationsService;



// WEBPACK FOOTER //
// ./app/components/_api/notifications.service.js